// extracted by mini-css-extract-plugin
module.exports = {"titleText":"e_A8","container":"e_B8","authorText":"e_C8","title":"e_D8","image":"e_E8","description":"e_F8","author":"e_G8","splitLine":"e_H8"};